export function groupMessages(messages) {
  const groups = [];

  let currentGroup = null;
  let lastDate = null;

  messages.forEach((msg, index) => {
    const msgDate = new Date(msg.created_at).toDateString();

    // 📅 DATE SEPARATOR
    if (msgDate !== lastDate) {
      groups.push({
        type: "date",
        date: msg.created_at,
      });
      lastDate = msgDate;
      currentGroup = null;
    }

    const prev = messages[index - 1];
    const isSystem = msg.type === "system";

    if (isSystem) {
      groups.push({
        type: "system",
        messages: [msg],
      });
      currentGroup = null;
      return;
    }

    const sameSender =
      prev &&
      prev.sender?.id === msg.sender?.id &&
      prev.type !== "system";

    const timeDiff =
      prev &&
      new Date(msg.created_at) - new Date(prev.created_at);

    const withinTime = timeDiff && timeDiff < 5 * 60 * 1000;

    if (sameSender && withinTime && currentGroup) {
      currentGroup.messages.push(msg);
    } else {
      currentGroup = {
        type: "user",
        sender: msg.sender,
        messages: [msg],
      };
      groups.push(currentGroup);
    }
  });

  return groups;
}